/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskType } from './TaskType';
import {
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
    TaskTypeToJSONTyped,
} from './TaskType';
import type { TaskStatus } from './TaskStatus';
import {
    TaskStatusFromJSON,
    TaskStatusFromJSONTyped,
    TaskStatusToJSON,
    TaskStatusToJSONTyped,
} from './TaskStatus';

/**
 * 
 * @export
 * @interface UpdateTaskExecutionRequest
 */
export interface UpdateTaskExecutionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskExecutionRequest
     */
    taskExecutionId: number;
    /**
     * 
     * @type {TaskStatus}
     * @memberof UpdateTaskExecutionRequest
     */
    taskStatus: TaskStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskExecutionRequest
     */
    durationMilliseconds: number;
    /**
     * 
     * @type {TaskType}
     * @memberof UpdateTaskExecutionRequest
     */
    taskType?: TaskType | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateTaskExecutionRequest
     */
    taskParams?: { [key: string]: any; } | null;
}



/**
 * Check if a given object implements the UpdateTaskExecutionRequest interface.
 */
export function instanceOfUpdateTaskExecutionRequest(value: object): value is UpdateTaskExecutionRequest {
    if (!('taskExecutionId' in value) || value['taskExecutionId'] === undefined) return false;
    if (!('taskStatus' in value) || value['taskStatus'] === undefined) return false;
    if (!('durationMilliseconds' in value) || value['durationMilliseconds'] === undefined) return false;
    return true;
}

export function UpdateTaskExecutionRequestFromJSON(json: any): UpdateTaskExecutionRequest {
    return UpdateTaskExecutionRequestFromJSONTyped(json, false);
}

export function UpdateTaskExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskExecutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taskExecutionId': json['task_execution_id'],
        'taskStatus': TaskStatusFromJSON(json['task_status']),
        'durationMilliseconds': json['duration_milliseconds'],
        'taskType': json['task_type'] == null ? undefined : TaskTypeFromJSON(json['task_type']),
        'taskParams': json['task_params'] == null ? undefined : json['task_params'],
    };
}

export function UpdateTaskExecutionRequestToJSON(json: any): UpdateTaskExecutionRequest {
    return UpdateTaskExecutionRequestToJSONTyped(json, false);
}

export function UpdateTaskExecutionRequestToJSONTyped(value?: UpdateTaskExecutionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_execution_id': value['taskExecutionId'],
        'task_status': TaskStatusToJSON(value['taskStatus']),
        'duration_milliseconds': value['durationMilliseconds'],
        'task_type': TaskTypeToJSON(value['taskType']),
        'task_params': value['taskParams'],
    };
}

